import * as sagaEffects from 'redux-saga/effects';
import { push } from 'connected-react-router';

import config from 'config/index';

import types from '../actionTypes';

const { takeEvery, put } = sagaEffects;

function* handler() {
    yield put(push(config.routes.pinsAdd));
}
export default function* () {
    yield takeEvery(types.SET_NEW_PIN, handler);
}
